import React from 'react';
import { useSelector } from 'react-redux';

import { useActionDispatcher } from '../../../hooks/index';
import ProjectForm from './ProjectForm';
import { saveProjectRequest } from '../../../store/modules/projects/actions';
import { selectProject } from '../../../store/modules/projects/selectors';

const ProjectEdit = () => {
  const project = useSelector(selectProject);
  const saveProject = useActionDispatcher(saveProjectRequest);

  return <ProjectForm record={project} onSubmit={saveProject} />;
};

export default ProjectEdit;
